import type { IOrgEmployeeResDto } from '~packages/epk-front-shared/api-client';
import type { IEmployeeDto } from '~packages/epk-org-client/ui';

export const employeeListFactory = (
  employeeDtoArr: IOrgEmployeeResDto[]
): IEmployeeDto[] => {
  return employeeDtoArr.map(i => {
    return {
      accesses: i.accesses,
      department: i.user_department,
      user: i.user,
    };
  });
};
